import { render, staticRenderFns } from "./nav.vue?vue&type=template&id=5fa056fe&scoped=true"
import script from "./nav.vue?vue&type=script&lang=js"
export * from "./nav.vue?vue&type=script&lang=js"
import style0 from "./nav.vue?vue&type=style&index=0&id=5fa056fe&prod&lang=scss&scoped=true"
import style1 from "./nav.vue?vue&type=style&index=1&id=5fa056fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa056fe",
  null
  
)

export default component.exports